<mat-card appearance="outlined" *appRoles="['Expedientes.Ver']">
  <!-- Cabecera -->
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Expedientes</h2>
      <div *ngIf="!idCaso">
        <app-button-new [routerLink]="['/expedientes/create']" *appRoles="['Expedientes.Crear']" #tooltip="matTooltip"
          matTooltip="Crear expediente."></app-button-new>
      </div>
    </div>


  </mat-card-header>
  <!-- Contenido de filtros -->
  <!-- <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Caratula</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Caratula" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>IdentificadorUnico</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="IdentificadorUnico" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Número</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Numero" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-checkbox formControlName="ClaveSisfe">Sin Clave</mat-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaEstadoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado Expediente</mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="EstadoExpediente">
              <mat-option [value]="estadoExpediente.id" *ngFor="
                  let estadoExpediente of estadosExpediente;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ estadoExpediente.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaTipoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Expediente </mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="TipoExpediente">
              <mat-option [value]="tipoExpediente.id" *ngFor="
                  let tipoExpediente of tiposExpediente;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ tipoExpediente.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaJuzgados" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Juzgados </mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="Juzgado">
              <mat-option [value]="juzgado.id" *ngFor="
                  let juzgado of juzgados;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ juzgado.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content> -->

  <mat-card-content>
    <form [formGroup]="formFilter">
      <!-- Cabecera principal con filtros básicos y botones -->
      <div class="filter-header">
        <!-- Filtros básicos a la izquierda -->
        <div class="basic-filters">
          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Carátula</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Caratula"
              placeholder="Ingrese carátula" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field">
            <mat-label>CUIJ</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="IdentificadorUnico"
              placeholder="Ingrese CUIJ" />
          </mat-form-field>


        </div>

        <!-- Botones de acción a la derecha -->
        <!-- <div class="action-buttons">
          <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
          <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>

          <button  mat-icon-button matTooltip="Filtros avanzados" type="button" class="small-icon-btn" [matMenuTriggerFor]="menuFiltroAvanzado"
            [class.active]="checkedFiltroAvanzado" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
            <mat-icon>tune</mat-icon>
          </button>
        </div> -->

        <app-action-buttons-filter [checkedFiltroAvanzado]="checkedFiltroAvanzado"
          [menuFiltroAvanzado]="menuFiltroAvanzado" (aplicarFiltro)="aplicarFiltro()" (limpiarFiltro)="limpiarFiltro()"
          (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()">
        </app-action-buttons-filter>
      </div>

      <!-- Menú contextual (alternativo al panel expandible) -->
      <mat-menu #menuFiltroAvanzado="matMenu" class="advanced-filters-menu">
        <div class="menu-content" (click)="$event.stopPropagation()">
          <h4 class="menu-title">Filtros Avanzados</h4>
          <mat-form-field appearance="outline" class="advanced-field">
            <mat-label>Número</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Numero" />
          </mat-form-field>



          <!-- Estado Expediente -->
          <mat-form-field appearance="outline" class="advanced-field">
            <mat-label>Estado Expediente</mat-label>
            <mat-select placeholder="Seleccione estado(s)" multiple formControlName="EstadoExpediente">
              <mat-option [value]="estadoExpediente.id"
                *ngFor="let estadoExpediente of estadosExpediente; trackBy: trackByItems">
                {{ estadoExpediente.descripcion }}
              </mat-option>
            </mat-select>
            <ngx-spinner [zIndex]="-1" name="spBusquedaEstadoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color="var(--primary-color)" type="line-scale" [fullScreen]="false">
            </ngx-spinner>
          </mat-form-field>

          <!-- Tipo Expediente -->
          <mat-form-field appearance="outline" class="advanced-field">
            <mat-label>Tipo Expediente</mat-label>
            <mat-select placeholder="Seleccione tipo" formControlName="TipoExpediente">
              <mat-option [value]="tipoExpediente.id"
                *ngFor="let tipoExpediente of tiposExpediente; trackBy: trackByItems">
                {{ tipoExpediente.descripcion }}
              </mat-option>
            </mat-select>
            <ngx-spinner [zIndex]="-1" name="spBusquedaTipoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color="var(--primary-color)" type="line-scale" [fullScreen]="false">
            </ngx-spinner>
          </mat-form-field>

          <!-- Juzgados -->
          <mat-form-field appearance="outline" class="advanced-field">
            <mat-label>Juzgados</mat-label>
            <mat-select placeholder="Seleccione juzgado(s)" multiple formControlName="Juzgado">
              <mat-option [value]="juzgado.id" *ngFor="let juzgado of juzgados; trackBy: trackByItems">
                {{ juzgado.descripcion }}
              </mat-option>
            </mat-select>
            <ngx-spinner [zIndex]="-1" name="spBusquedaJuzgados" bdColor="rgba(255,255,255,0.8)" size="small"
              color="var(--primary-color)" type="line-scale" [fullScreen]="false">
            </ngx-spinner>
          </mat-form-field>

          <mat-checkbox formControlName="ClaveSisfe">Sin Clave SISFE</mat-checkbox>
        </div>
      </mat-menu>
    </form>
  </mat-card-content>


  <mat-card-content>

    <ngx-spinner [zIndex]="100" name="spExpediente" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>


    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <app-button-action *ngIf="data"
          [actions]="[
      { label: 'Solicitar clave', icon: 'key', handler: solicitarClavePorCorreo, roles: ['Expedientes.Modificar'] }]"></app-button-action>

        <app-button-export-excel *ngIf="data" [data]="expedienteDatosPlanos" [fileName]="'Expedientes'"
          [sheetName]="'Expedientes'" [columns]="columns">
        </app-button-export-excel>


      </div>
      <app-input-filter-table (filterChange)="applyFilter($event)" [tooltip]="'Buscar por nombre, descripción, etc.'"
        *ngIf="data">
      </app-input-filter-table>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <!-- Tabla De datos -->
    <div>
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(expediente) : null"
              [checked]="selection.isSelected(expediente)" [aria-label]="checkboxLabel(expediente)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="caratula">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Caratula</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente">
            <span>{{ expediente.caratula | uppercase }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="identificadorUnico">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>IdentificadorUnico</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente">
            <span><a [routerLink]="['/expedientes/', expediente.id]">{{
                expediente.identificadorUnico | uppercase
                }}</a></span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoExpediente">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado Exte.</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente">
            <span>{{
              expediente.estadoExpediente?.descripcion | uppercase
              }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaModificacion">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha Modificación</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente">
            <span>{{
              expediente.fechaModificacion == undefined
              ? ""
              : (expediente.fechaModificacion | date : "dd/MM/yyyy")
              }}</span>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let expediente" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item [routerLink]="['/expedientes/', expediente.id]" *appRoles="['Expedientes.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item [routerLink]="['/expedientes/edit/', expediente.id]"
                *appRoles="['Expedientes.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog('Eliminar', expediente)" *appRoles="['Expedientes.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></mat-row>
      </table>

      <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
